module.exports = __webpack_public_path__ + "static/media/aboutimg2.5f124e89.webp";